import logoImg from '@/images/logo.svg'
import { Link } from 'react-router-dom'

export const VendorLogo = () => {
  return (
    <div className="flex">
      <Link to="/">
        <img src={logoImg} alt="Логотип" />
      </Link>
    </div>
  )
}